import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ContextLanguage } from "../../../context/Context.Language";
import { ICON_CHEVRON_LEFT } from "../../../utils/useIcons";
import { STYLE_BUTTON_ICON_LEFT } from "../../../utils/useStyle";
import ProgramClickBack from "../functions/Program.ClickBack";

export const ProgramGoBackMap = ({
  title,
  textcolor,
  setOpen,
  onClick = false,
  onClickMain,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { language } = React.useContext(ContextLanguage);

  return (
    <div className="">
      <div
        onClick={onClickMain}
        className={`${
          language === "TH"
            ? " text-xl-th md:text-28-th "
            : " text-xl md:text-28 "
        } items-center text-center text-laudry-gray-200   h-16 md:h-20 mb-[10px] md:mb-0 `}
      >
        <ICON_CHEVRON_LEFT
          className={STYLE_BUTTON_ICON_LEFT}
          onClick={(e) => {
            if (onClick) {
              onClick(e);
            } else if (setOpen) {
              setOpen(false);
            } else {
              ProgramClickBack(navigate);
            }
          }}
        />
        <div className={textcolor}>{title}</div>
      </div>
    </div>
  );
};

const ProgramGoBack = ({
  absolute = " left-1/2 transform -translate-x-1/2 ",
  title,
  classname = "",
  textcolor = "",
  setOpen,
  onClick = false,
  onClickMain,
  marginarrow,
  hiddenButton,
}) => {
  const navigate = useNavigate();

  const { language } = React.useContext(ContextLanguage);

  return (
    <div className="">
      <div
        onClick={onClickMain}
        className={` ${classname} ${
          language === "TH"
            ? " text-xl-th md:text-28-th "
            : " text-xl md:text-28 "
        } . items-center text-center text-laudry-gray-200  leading-6 md:leading-8 font-bold h-16 md:h-20 mb-[10px] md:mb-0  relative flex w-full`}
      >
        {!hiddenButton && (
          <ICON_CHEVRON_LEFT
            className={`${STYLE_BUTTON_ICON_LEFT} flex-none ${marginarrow}`}
            onClick={(e) => {
              if (onClick) {
                onClick(e);
              } else if (setOpen) {
                setOpen(false);
              } else {
                ProgramClickBack(navigate);
              }
            }}
          />
        )}
        <div
          className={`${textcolor} ${absolute} text-center flex-shrink mx-auto pr-2 absolute  `}
        >
          {title}
        </div>
      </div>
    </div>
  );
};

export default ProgramGoBack;
